































import { LANG } from "@/common/constant";
import _xor from "lodash/xor";
import { Component, Prop } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qLanguageBox",
})
export default class QLanguageBox extends Vue {
  @Prop({
    required: true,
    default: [LANG.EN],
  })
  public value: any;

  get isCheckedEnLang() {
    return this.value.includes(LANG.EN);
  }

  get isCheckedCnLang() {
    return this.value.includes(LANG.CN);
  }

  public addOrRemoveLang(value: string) {
    this.$emit("input", _xor(this.value, [value]));
  }
}
